import React from "react";

import "./text-area.scss";

const TextArea = ({ placeholder, onChange }) => {
  return (
    <textarea
      className="text-area"
      placeholder={placeholder}
      onChange={onChange}
    ></textarea>
  );
};

export default TextArea;
